import React from 'react';
import reactCSS from 'reactcss';
import { ChromePicker } from 'react-color';

class HexPicker extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      displayColorPicker: false,
      color: this.props.hexValue ? this.props.hexValue : '#000',
    };
  }

  handleClick = () => {
    this.setState({ displayColorPicker: !this.state.displayColorPicker });
  };

  handleClose = () => {
    this.setState({ displayColorPicker: false });
  };

  handleChange = color => {
    this.setState({ color: color.hex });

    this.props.setCropBackgroundHex(color.hex);
  };

  render() {
    const styles = reactCSS({
      default: {
        label: {
          fontSize: '14px',
          lineHeight: '24px',
          verticalAlign: 'top',
          margin: '0 10px 0 0',
        },
        color: {
          width: '36px',
          height: '14px',
          borderRadius: '2px',
          background: `${this.state.color}`,
        },
        swatch: {
          padding: '5px',
          background: '#fff',
          borderRadius: '1px',
          boxShadow: '0 0 0 1px rgba(0,0,0,.1)',
          display: 'inline-block',
          cursor: 'pointer',
        },
        popover: {
          position: 'absolute',
          zIndex: '2',
        },
        cover: {
          position: 'fixed',
          top: '0px',
          right: '0px',
          bottom: '0px',
          left: '0px',
        },
      },
    });

    return (
      <div>
        <span style={styles.label}>Choose color:</span>
        <div style={styles.swatch} onClick={this.handleClick}>
          <div style={styles.color} />
        </div>
        {this.state.displayColorPicker ? (
          <div style={styles.popover}>
            <div style={styles.cover} onClick={this.handleClose} />
            <ChromePicker color={this.state.color} onChange={this.handleChange} disableAlpha={true} />
          </div>
        ) : null}
      </div>
    );
  }
}

export default HexPicker;



// WEBPACK FOOTER //
// ./src/components/HexPicker/hexPicker.js